<template>
    <div id="bucketlist_main">
        <div class="bucketlist_bucket" v-for="bucket in buckets" @click="select(bucket)">
            <i class="fas fa-box-open fc-main"></i>
            <span class="ff-varela fs-big fc-black">{{ bucket.name }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "bucketList",
        props: ['buckets'],
        data(){
            return{

            }
        },
        computed: {

        },
        methods: {
            select(bucket){
                this.$emit('selectBucket', bucket)
            }
        }
    }
</script>

<style scoped>
    #bucketlist_main{
        display: flex;
        width: 100%;
        flex-direction: column;
    }
    .bucketlist_bucket{
        display: flex;
        height: 100px;
        width: 100%;
        border: 1px solid var(--color-gray);
        align-items: center;
    }
    .bucketlist_bucket:hover{
        background-color: var(--color-main-faded);
        cursor: pointer;
    }
    .bucketlist_bucket i{
        display: flex;
        padding-left: 20px;
        padding-right: 5px;
    }
    .bucketlist_bucket span{
        display: flex;
    }
</style>
